import React, { useContext } from 'react';
import { Flex, Row, message, Divider, Input } from 'antd';
import FormRender, { useForm } from 'form-render';
import { FormConfigProvider, FormConfigContext } from './provider';
import ChooseGoods from './choose-goods';
import ChooseCoupon from './choose-coupon';
import ChooseGoodsCard from './choose-goods-card';
import ChooseCate from './choose-cate';
import ChoosePage from './choose-page';
import ChoosePlatformCate from './choose-platform-cate';
import Upload from './upload';
import './comp-form.css';

const iconStyle = {
    fontSize: 28,
}


export default (props) => {
    const { onFinish, form, schema, accId, shopId, ...others } = props;
    return (
        <FormConfigProvider config={{ accId, shopId }}>
            <FormRender 
                className='customer-form-render'
                widgets={{ ChooseGoods, ChooseCoupon, ChooseGoodsCard, ChooseCate, ChoosePage, ChoosePlatformCate, Upload }}
                form={form} 
                schema={schema} 
                onFinish={onFinish} 
                {...others}
            />
        </FormConfigProvider>
    );
};